import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UpsertTicketCommentProgress, UpsertTicketCommentState } from '../upsert-ticket-comment/upsert-ticket-comment.component';
import { EscalatedTicket, TicketComment } from '@shared/services';


@Component({
  selector: 'app-upsert-ticket-comment-modal',
  templateUrl: './upsert-ticket-comment-modal.component.html',
  styleUrls: ['./upsert-ticket-comment-modal.component.scss'],
  standalone: false
})
export class UpsertTicketCommentModalComponent implements OnChanges {

  @Input() ticket: EscalatedTicket;
  @Input() comment: TicketComment;
  @Input() includeTicketUpdateFields = true;

  isCreate = true;
  updating = false;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.comment) {
      this.isCreate = !this.comment;
    }
  }

  onUpsertCommentProgress(progress: UpsertTicketCommentProgress) {
    switch (progress.state) {
      case UpsertTicketCommentState.PROCESSING:
        this.updating = true;
        break;

      case UpsertTicketCommentState.DONE:
        this.updating = false;
        const progressResult = progress.result;
        this.activeModal.close({
          comment: progressResult?.comment,
          ticket: progressResult?.ticket
        });
        break;

      case UpsertTicketCommentState.ERROR:
        this.updating = false;
        // https://github.com/angular/angular/issues/15926
        throw progress.error instanceof HttpErrorResponse ? new Error(progress.error.message) : progress.error;
      }
  }

  onCancel() {
    this.activeModal.dismiss('cancel');
  }

}
